import React from "react";
import CustomSelect from "components/customs/dropdown";
import { dropdownSelectStyle } from "constants/style";
import { Col } from "reactstrap";
import styled from "styled-components";
import SearchBarComponent from "components/customs/searchbarV2";
import { canEditRoles } from "utility/constants";
import { Plus, Settings } from "react-feather";
import useAuth from "hooks/useAuth";
import { AddButton } from "assets/js/Styles";
import { Link } from "react-router-dom";
import { hasPermission } from "utility/helpers";
import { ADD_ACTION } from "constants/actions";

const Wrapper = styled.div`
  margin-top: 44px;
`;

const Container = styled.div`
  padding: 0;
  display: grid;
  gap: 16px;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 1fr 40px auto;

  @media (max-width: 575px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const SettingsIconWrapper = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const SearchbarWrapper = styled.div`
  width: 100%;
  position: relative;

  input {
    border: 2px solid ${({ theme }) => theme.colors.black60};
    background: white;
    box-shadow: none;
    border-radius: 9px;
    height: clamp(35px, 5vw, 50px);
  }
`;

const StyledSettings = styled.div`
  display: flex;
  background: #e0e7ff;
  border-radius: 50%;
  padding: 8px;
  color: #0000ff;

  svg {
    cursor: pointer;
  }
`;

const AddButtonText = styled.span`
  padding-left: 8px;
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.63px;
`;

const StyledAddButton = styled(AddButton)`
  width: 130%;
  background: ${({ theme }) => theme.colors.buttonBlue};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const UtilizationReportsFilters = ({
  congressmenOptions,
  selectedPrincipal,
  setSelectedPrincipal,
  displayOthersFilter,
  disablePrincipal,
  othersOptions,
  selectedOthers,
  agencyOptions,
  setSelectedOthers,
  selectedAgency,
  setSelectedAgency,
  setIsAllAgency,
  setSelectedProject,
  isAllAgency,
  projectOptions,
  selectedProject,
  onChangeSearch,
  toggleModal,
}) => {
  const { user } = useAuth();

  const role = user?.type;

  return (
    <Wrapper>
      <p>{"Select Filter"} </p>
      <Container>
        <CustomSelect
          placeholder="Principal"
          styles={dropdownSelectStyle}
          options={congressmenOptions}
          value={selectedPrincipal}
          onChange={(option) => {
            setSelectedPrincipal(option);
          }}
          isDisabled={disablePrincipal}
        />

        {displayOthersFilter && (
          <CustomSelect
            placeholder="Others"
            styles={dropdownSelectStyle}
            options={othersOptions}
            value={selectedOthers}
            onChange={(option) => setSelectedOthers(option)}
          />
        )}

        <CustomSelect
          placeholder="Agency"
          styles={dropdownSelectStyle}
          options={agencyOptions}
          value={selectedAgency}
          onChange={(option) => {
            setSelectedAgency(option);

            if (option.id === 0) {
              setIsAllAgency(true);
              setSelectedProject(null);
            } else setIsAllAgency(false);
          }}
          filterOption={(option, searchValue) =>
            option?.label
              ?.toLowerCase()
              ?.includes(searchValue?.toLowerCase()) ||
            option?.data?.acronym
              ?.toLowerCase()
              ?.includes(searchValue?.toLowerCase())
          }
        />

        <CustomSelect
          placeholder="Program"
          styles={dropdownSelectStyle}
          options={projectOptions}
          value={selectedProject}
          onChange={(option) => {
            setSelectedProject(option);
          }}
          isDisabled={
            selectedAgency === null ||
            selectedAgency?.value === 14 ||
            isAllAgency
          }
        />

        <SearchbarWrapper>
          <SearchBarComponent onChangeSearch={onChangeSearch} />
        </SearchbarWrapper>

        <SettingsIconWrapper>
          {canEditRoles.includes(role) && (
            <StyledSettings>
              <Settings
                onClick={() => {
                  toggleModal();
                }}
              />
            </StyledSettings>
          )}
        </SettingsIconWrapper>

        {hasPermission("utilization-create") && (
          <StyledLink
            to="/utilization/add"
            state={{ action: ADD_ACTION }}
          >
            <StyledAddButton>
              <Plus size={24} />
              <AddButtonText>{"Add"}</AddButtonText>
            </StyledAddButton>
          </StyledLink>
        )}
      </Container>
    </Wrapper>
  );
};

export default UtilizationReportsFilters;
